import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { Circle } from "lucide-react"

import { cn } from "@/lib/utils"
import { useGraphite } from "@/components/Graphite"

const RadioGroup = React.forwardRef(({ className, ...props }, ref) => {
  return (<RadioGroupPrimitive.Root className={cn("grid gap-2", className)} {...props} ref={ref} />);
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

// Graphite: a 16px ring in the input border; the chosen one fills its centre with primary
const GRAPHITE_RADIO = "aspect-square grid place-items-center h-4 w-4 rounded-full border border-input bg-background text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:cursor-not-allowed disabled:opacity-40 data-[state=checked]:border-primary"

const RadioGroupItem = React.forwardRef(({ className, ...props }, ref) => {
  const graphite = useGraphite()
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        graphite ? GRAPHITE_RADIO : "aspect-square h-4 w-4 rounded-full border border-primary text-primary shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}>
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        <Circle className={graphite ? "h-2 w-2 fill-primary" : "h-3.5 w-3.5 fill-primary"} />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
